import { render, staticRenderFns } from "./Spot.vue?vue&type=template&id=65c9db69&scoped=true"
import script from "./Spot.vue?vue&type=script&lang=js"
export * from "./Spot.vue?vue&type=script&lang=js"
import style0 from "./Spot.vue?vue&type=style&index=0&id=65c9db69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9db69",
  null
  
)

export default component.exports